import { 
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  ContentChildren,
  QueryList,
  AfterContentInit,
  OnDestroy } from '@angular/core';
import { ColumnGroupComponent } from '../column-group/column-group.component';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

class ColumnGroup {
  constructor(
    public index: number,
    public label: string,
    public component: ColumnGroupComponent
  ) {}
}

@Component({
  selector: 'app-column',
  templateUrl: './column.component.html',
  styleUrls: ['./column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColumnComponent implements OnInit, AfterContentInit, OnDestroy {
  @ContentChildren(ColumnGroupComponent)
  columnGroupsQuery: QueryList<ColumnGroupComponent>;

  @Input()
  label: string;

  @Input()
  showHeader = true;

  @Input()
  loading = false;

  @Input()
  loadingLabel = '';

  @Input()
  public get selectedColumnGroup(): string | number {
    return this._selectedColumnGroup.value;
  }
  public set selectedColumnGroup(value: string | number) {
    if (value != null && value !== this.selectedColumnGroup) {
      if (typeof value === 'string') {
        value = value.toUpperCase();
      }
      this._selectedColumnGroup.next(value);
      this.selectedColumnGroupChange.emit(value);
    }
  }
  _selectedColumnGroup: BehaviorSubject<string | number> = new BehaviorSubject<string | number>(0);

  @Output()
  selectedColumnGroupChange = new EventEmitter<string|number>();

  @Output()
  next = new EventEmitter();

  @Output()
  previous = new EventEmitter();

  columnGroups: ColumnGroup[];
  ngUnsubscribe = new Subject();

  constructor() { }

  ngOnInit() {
  }

  ngAfterContentInit() {
    this.mapContentGroups();

    this._selectedColumnGroup
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((columnGroup) => {
        this.showColumnGroup(columnGroup);
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleColumnGroupSelect(columnGroup: ColumnGroup) {
    // this._selectedColumnGroup.next(columnGroup.index);
    this.selectedColumnGroup = columnGroup.label;
  }

  mapContentGroups() {
    this.columnGroups = this.columnGroupsQuery.map((columnGroup, index) => {
      return new ColumnGroup(
        index,
        columnGroup.label,
        columnGroup
      );
    });
  }

  showColumnGroup(selector: string | number) {
    this.columnGroups.forEach((group, index) => {
      switch (typeof selector) {
        case 'number':
          group.component.isActive = (selector === index);
          break;
        case 'string':
          group.component.isActive = (selector.toString().toUpperCase() === group.label.toUpperCase());
          break;
      }
    });
  }

  isColumnGroupSelected(columnGroup: ColumnGroup) {
    const value = (typeof this._selectedColumnGroup.value === 'string') ? columnGroup.label.toUpperCase() : columnGroup.index;
    return value === this._selectedColumnGroup.value;
  }

}
